/** Barrel for shared standalone UI components + the translate pipe. */
export { TranslatePipe } from './pipes/translate.pipe';
export { RevealDirective } from './directives/reveal.directive';
export { AutoRevealDirective } from './directives/auto-reveal.directive';
export { IconComponent } from './components/icon.component';
export { PriceComponent } from './components/price.component';
export { BtnComponent } from './components/btn.component';
export { ChipComponent } from './components/chip.component';
export { TagComponent } from './components/tag.component';
export { StarsComponent } from './components/stars.component';
export { StepperComponent } from './components/stepper.component';
export { SpinnerComponent } from './components/spinner.component';
export { SectionHeadComponent } from './components/section-head.component';
export { LogoComponent } from './components/logo.component';
export { FoodImgComponent } from './components/food-img.component';
export { ImgSlotComponent } from './components/img-slot.component';
export { SheetComponent } from './components/sheet.component';
export { ConfirmDialogComponent } from './components/confirm-dialog.component';
export { SoldOutVeilComponent } from './components/sold-out-veil.component';
export { OrderStatusComponent } from './components/order-status.component';
export { OrderRowComponent } from './components/order-row.component';
export { EmptyStateComponent } from './components/empty-state.component';
export { ItemCardComponent } from './components/item-card.component';
export { ItemRowComponent } from './components/item-row.component';
export { CategoryTileComponent } from './components/category-tile.component';
export { PromoCardComponent } from './components/promo-card.component';
export { TabBarComponent } from './components/tab-bar.component';
export { CartBarComponent } from './components/cart-bar.component';
export { FulfillmentBarComponent } from './components/fulfillment-bar.component';
export { PageHeaderComponent } from './components/page-header.component';
export { MapPickerComponent, LatLng, MAP_DEFAULT_CENTER } from './components/map-picker.component';
export { FOOD_TONES, toneDef } from './components/food-tones';
export { DeskHeadComponent } from './components/desk-head.component';
export { DeskItemCardComponent } from './components/desk-item-card.component';
export type { CardItem } from './components/desk-item-card.component';
export { CartPanelComponent } from './components/cart-panel.component';
